const FIELD_SELECTOR = 'input, textarea, select';

function autocompleteValue(element: HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement): string {
  return element instanceof HTMLInputElement && element.type === 'password'
    ? 'new-password'
    : 'nofill';
}

function applyToElement(element: Element): void {
  if (element instanceof HTMLFormElement) {
    element.setAttribute('autocomplete', 'off');
    return;
  }
  if (element.getAttribute('name') === 'phone' || element.getAttribute('name') === 'cpf') {
    element.setAttribute('autocomplete', 'off');
    return;
  }

  if (
    element instanceof HTMLInputElement ||
    element instanceof HTMLTextAreaElement ||
    element instanceof HTMLSelectElement
  ) {
    element.setAttribute('autocomplete', autocompleteValue(element));
  }
}

function applyToTree(root: ParentNode): void {
  if (root instanceof Element && root.matches('form, ' + FIELD_SELECTOR)) {
    applyToElement(root);
  }

  root.querySelectorAll('form, ' + FIELD_SELECTOR).forEach(applyToElement);
}

export function disableBrowserAutocomplete(): () => void {
  applyToTree(document.body);

  const observer = new MutationObserver((mutations) => {
    for (const mutation of mutations) {
      mutation.addedNodes.forEach((node) => {
        if (node instanceof HTMLElement) {
          applyToTree(node);
        }
      });
    }
  });

  observer.observe(document.body, { childList: true, subtree: true });

  return () => observer.disconnect();
}
